import './styles.css'

function ShareSettings({ shareType, onShareTypeChange }) {
  return (
    <div className="share-settings">
      <label className="share-settings-label">Compartir como:</label>
      <div className="share-settings-options">
        <label className="radio-option">
          <input
            type="radio"
            name="shareType"
            value="png"
            checked={shareType === 'png'}
            onChange={(e) => onShareTypeChange(e.target.value)}
          />
          <span className="radio-label">imagen.png</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="shareType"
            value="pdf"
            checked={shareType === 'pdf'}
            onChange={(e) => onShareTypeChange(e.target.value)}
          />
          <span className="radio-label">archivo.pdf</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="shareType"
            value="xls"
            checked={shareType === 'xls'}
            onChange={(e) => onShareTypeChange(e.target.value)}
          />
          <span className="radio-label">archivo.xls</span>
        </label>
      </div>
    </div>
  )
}

export default ShareSettings
